export default defineNuxtPlugin({
  name: 'smartlook',
  parallel: true,
  setup () {
    const userState = useUserState();

    watch(userState, (newUserState) => {
      if (newUserState) {
        window.smartlook?.('identify', newUserState.sub, {
          email: newUserState.email,
        });
      } else {
        window.smartlook?.('anonymize');
      }
    }, { immediate: true });
  }
});
